import { combineReducers } from 'redux';

import NerveReducer from './nerveReducer';
import NerveModalReducer from './nerveModalReducer';
import InfoModalReducer from './infoModalReducer';
import InfoModalDetailReducer from './infoModalDetailReducer';
import CursorReducer from './cursorReducer';
import CursorTextReducer from './cursorTextReducer';
import UlnarMuscleReducer from './ulnarMuscleReducer';
import MedianMuscleReducer from './medianMuscleReducer';
import BrachialPlexusMuscleColor from './brachialPlexusMuscleReducer';
import DemoModalReducer from './demoModalReducer';
import AuthUserReducer from './authUserReducer';

const rootReducer = combineReducers({
    selectedNerve: NerveReducer,
    nerveModalState: NerveModalReducer,
    cursorOpacity: CursorReducer,
    cursorTextOpacity: CursorTextReducer,
    infoModalState: InfoModalReducer,
    infoModalDetails: InfoModalDetailReducer,
    ulnarMuscleColor: UlnarMuscleReducer,
    brachialPlexusMuscleColor: BrachialPlexusMuscleColor,
    medianMuscleColor: MedianMuscleReducer,
    demoModalState: DemoModalReducer,
    authUser: AuthUserReducer,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js